const uuidv1 = require("uuid/v1");
import { geo } from "../geo/geo";
import { fix2digit } from "../filters/utility";
import { dateHelper } from "../dateHelper/dateHelper";
import { DateTime } from "luxon";
import { formatPhoneForPos, isValidPhone } from "../validation/phoneHelper";
export function VenueHelper() {
  this.getVenuesByOrder = function getVenuesByOrder(venues) {
    let copy = [...venues];
    const pos = geo.getLocation();
    venues = copy.sort((a, b) => {
      let d1 = geo.distanceFromPos(
        pos,
        a.Location.Latitude,
        a.Location.Longitude
      );
      let d2 = geo.distanceFromPos(
        pos,
        b.Location.Latitude,
        b.Location.Longitude
      );
      return d1 - d2;
    });
  };

  this.getVenueNumberOfGuestInfo = function getVenueNumberOfGuestInfo(
    venueInfo
  ) {
    var minGuest = 1;
    var maxGuest = 20;
    var numberOfGuestList = [];
    var viewConfig = venueInfo.ViewComponentConfigs;
    if (viewConfig) {
      minGuest = viewConfig.MinGuest ? viewConfig.MinGuest : minGuest;
      maxGuest = viewConfig.MaxGuest ? viewConfig.MaxGuest : maxGuest;
    }
    for (var i = minGuest; i <= maxGuest; i++) {
      numberOfGuestList.push(i);
    }
    return {
      minGuest: minGuest,
      maxGuest: maxGuest,
      numberOfGuestsList: numberOfGuestList,
    };
  };

  this.populateBookingTypes = function populateBookingTypes(venueInfo) {
    let bookingTypes = new Array();
    let finalBookinTypes = new Array();
    if (!venueInfo.Categories) return;
    var keys = Object.keys(venueInfo.Categories);

    var values = Object.values(venueInfo.Categories);
    for (var i = 0; i < keys.length; i++) {
      if (values[i] == true) {
        bookingTypes.push(keys[i]);
      }
    }

    if (bookingTypes.length > 0)
      finalBookinTypes.push("[Choose Reservation Type]");

    for (
      var bookingTypeIndex = 0;
      bookingTypeIndex < bookingTypes.length;
      bookingTypeIndex++
    ) {
      finalBookinTypes.push(bookingTypes[bookingTypeIndex]);
    }
    return finalBookinTypes;
  };
  this.populateVenues = function populateVenues(companyProfile) {
    let venues = [];
    if (!companyProfile.IsHQ) {
      venues.push(companyProfile);
    } else {
      for (let i = 0; i < companyProfile.Venues.length; i++)
        if (companyProfile.Venues[i]) venues.push(companyProfile.Venues[i]);
    }
    return {
      venueInfo: companyProfile,
      HqInfo: companyProfile,
      venues: venues,
    };
  };

  this.getStoreTime = function getStoreTime(
    TimezoneIanaFormat,
    bookingDateParameter
  ) {
    var now = DateTime.local();
    var offset = now.offset - now.setZone(TimezoneIanaFormat).offset;
    var dateTime = new Date(
      DateTime.fromJSDate(new Date(bookingDateParameter)).plus({
        minute: offset,
      })
    );
    return dateTime;
  };

  this.hasPayment = function hasPayment(reservationInfo) {
    const venuInfo = reservationInfo.venueInfo || {};
    const depositValid =
      (venuInfo.DepositPerGuest && venuInfo.DepositPerGuest > 0) ||
      (venuInfo.DepositPerReservation && venuInfo.DepositPerReservation > 0);
    const minGuestValid =
      !venuInfo.DepositRequiredMinGuests ||
      (venuInfo.DepositRequiredMinGuests > 0 &&
        venuInfo.DepositRequiredMinGuests <= reservationInfo.numberOfGuests);
    return depositValid && minGuestValid;
  };
  this.validateBookingInfo = function validateBookingInfo(
    configurationInfo,
    reservationInfo,
    guestInfo
  ) {
    let validationStatus = {};
    if (configurationInfo.wizardIndex == 0) {
      if (
        reservationInfo.venue != 0 &&
        reservationInfo.numberOfGuests != "" &&
        reservationInfo.date != "" &&
        reservationInfo.time != "" &&
        reservationInfo.exactTime != ""
      ) {
        validationStatus.reservationInfoValidated = true;
      } else {
        validationStatus.reservationInfoValidated = false;
      }
    } else {
      if (guestInfo.firstName.length < 2 && guestInfo.firstName.length > 0) {
        validationStatus.firstNameValidated = false;
      } else {
        validationStatus.firstNameValidated = true;
      }

      if (guestInfo.lastName.length < 2 && guestInfo.lastName.length > 0) {
        validationStatus.lastNameValidated = false;
      } else {
        validationStatus.lastNameValidated = true;
      }

      if (
        guestInfo.phoneNumber.length > 0 &&
        !isValidPhone(guestInfo.phoneNumber, guestInfo.countryIso)
      ) {
        validationStatus.phoneValidated = false;
      } else {
        validationStatus.phoneValidated = true;
      }

      if (guestInfo.email) {
        if (!validateEmail(guestInfo.email) && guestInfo.email.length > 0) {
          validationStatus.emailValidated = false;
        } else {
          validationStatus.emailValidated = true;
        }
      } else {
        validationStatus.emailValidated = true;
      }
      if (
        validationStatus.firstNameValidated &&
        guestInfo.firstName != "" &&
        validationStatus.lastNameValidated &&
        guestInfo.lastName != "" &&
        validationStatus.emailValidated &&
        guestInfo.email != "" &&
        validationStatus.phoneValidated &&
        guestInfo.phoneNumber != ""
      ) {
        validationStatus.guestInfoValidated = true;
      } else {
        validationStatus.guestInfoValidated = false;
      }
    }
    return validationStatus;
  };

  this.paymentValue = function paymentValue(reservationInfo) {
    if (this.hasPayment(reservationInfo)) {
      return reservationInfo.venueInfo.DepositPerReservation > 0
        ? reservationInfo.venueInfo.DepositPerReservation
        : fix2digit(
            reservationInfo.venueInfo.DepositPerGuest *
              reservationInfo.numberOfGuests
          );
    } else {
      return 0;
    }
  };

  this.isDepositPerGeust = function isDepositPerGeust(reservationInfo) {
    return !(
      reservationInfo.venueInfo.DepositRequiredMinGuests > 0 &&
      reservationInfo.venueInfo.DepositPerReservation > 0
    );
  };
  this.createBookingInfoObject = function createBookingInfoObject(
    reservationInfo,
    guestInfo,
    reservationItems,
    configurationInfo,
    cardInfo
  ) {
    let bookingInfo = {};
    bookingInfo.ArrivalStatus = 0;
    bookingInfo.BookingDateTime = this.getStoreTime(
      reservationInfo.venueInfo.TimezoneIanaFormat,
      dateHelper.fullDateTimeFormat(
        reservationInfo.date,
        reservationInfo.exactTime,
        "yyyy/MM/dd hh:mm:ss a"
      )
    ).toString();

    bookingInfo.BookingEndingDateTime = this.getStoreTime(
      reservationInfo.venueInfo.TimezoneIanaFormat,
      dateHelper.addMinutesFullDateTimeFormat(
        reservationInfo.date,
        reservationInfo.exactTime,
        "yyyy/MM/dd hh:mm:ss a",
        30
      )
    ).toString();
    bookingInfo.Status = 6;

    bookingInfo.BookingName = guestInfo.firstName + " " + guestInfo.lastName;

    if (
      reservationInfo.bookingType &&
      reservationInfo.bookingType != reservationItems.bookingTypes[0]
    ) {
      bookingInfo.Category = reservationInfo.bookingType;
    }

    bookingInfo.Phone = formatPhoneForPos(
      guestInfo.phoneNumber,
      guestInfo.countryIso
    );

    bookingInfo.Company_ID = reservationInfo.venue;

    bookingInfo.HQCompany_ID = this.storeid;

    bookingInfo.Note = guestInfo.note;

    reservationItems.venues.forEach((ven) => {
      if (ven.id == reservationInfo.venue) {
        bookingInfo.CompanyName = ven.name;
      }
    });

    bookingInfo.CustomerSpend =
      guestInfo.numberOfGuests * configurationInfo.minimumDepositPerGuest;

    bookingInfo.Uuid = uuidv1();
    bookingInfo.GuestCount = reservationInfo.numberOfGuests;
    bookingInfo.Email = guestInfo.email;
    if (this.hasPayment(reservationInfo)) {
      bookingInfo.Card = {
        CardHolder: cardInfo.CardHolder,
        CardNumber: cardInfo.CardNumber,
        ExpiryMonth: cardInfo.ExpireDate.split("/")[0],
        ExpiryYear: cardInfo.ExpireDate.split("/")[1],
        Cvv: cardInfo.CVV,
      };
      bookingInfo.Deposit = this.paymentValue(reservationInfo);
    } else {
      bookingInfo.Deposit = 0;
    }
    return bookingInfo;
  };

  this.populateTimes = function populateTimes(
    availableTimes,
    availableSeats,
    numberOfGuest,
    reservationInfo,
    currentMoment = dateHelper.getMoment()
  ) {
    let times = [];
    for (var i = 0; i < availableTimes.length; i++) {
      if (availableSeats[i] >= numberOfGuest) {
        if (reservationInfo.date) {
          var reserveDate = dateHelper.getDateTimeMoment(
            reservationInfo.date,
            availableTimes[i]
          );

          if (reserveDate > currentMoment) {
            times.push(
              dateHelper.fullDateTimeFormat(
                reservationInfo.date,
                availableTimes[i],
                "h:mm a"
              )
            );
          }
        } else {
          var res = reservationInfo.split("-");
          var reserveDate = dateHelper.getDateTimeMoment(
            new Date(Date.parse(res[2] + "-" + res[1] + "-" + res[0])),
            availableTimes[i]
          );
          if (reserveDate > currentMoment) {
            times.push(
              dateHelper.fullDateTimeFormat(
                new Date(Date.parse(res[2] + "-" + res[1] + "-" + res[0])),
                availableTimes[i],
                "h:mm a"
              )
            );
          }
        }
      }
    }
    return times;
  };

  this.pickDefaultTime = function pickDefaultTime(
    times,
    preTime,
    defaultTime,
    currentMoment = dateHelper.getMoment()
  ) {
    let pickedTime;
    times.forEach((item) => {
      if (
        dateHelper.getMomentOfTime(item) > currentMoment.plus({ minute: 31 }) &&
        !pickedTime
      ) {
        pickedTime = item;
      }
    });
    if (preTime != "" && times.indexOf(preTime) != -1) {
      pickedTime = preTime;
    }
    if (defaultTime != "" && times.indexOf(defaultTime) != -1) {
      pickedTime = defaultTime;
      defaultTime = "";
    }
    if (!pickedTime && times.length > 0) pickedTime = times[0];
    return { pickedTime: pickedTime, defaultTime: defaultTime };
  };

  this.populateAroundTimes = function populateAroundTimes(
    selectedTime,
    availableTimes
  ) {
    let exactTime;
    let aroundTimes = new Array();
    let currentTimeIndex = availableTimes.indexOf(selectedTime);
    for (var i = 0; i < 5; i++) {
      // < 5 for show 5 reserve time on page
      var index = currentTimeIndex - 2 + i;
      if (index < 0) {
        // check unavailable reserve time, add 2 reserve time before first reserve time
        aroundTimes.push(
          dateHelper.addMinutesToTime(availableTimes[0], index * 30, "h:mm a")
        );
      } else if (index > availableTimes.length - 1) {
        //check unavailable reserve time, add 2 reserve time after last reserve time
        aroundTimes.push(
          dateHelper.addMinutesToTime(
            availableTimes[availableTimes.length - 1],
            (index - (availableTimes.length - 1)) * 30,
            "h:mm a"
          )
        );
      } else {
        aroundTimes.push(availableTimes[index]);
      }
    }

    exactTime = selectedTime;
    if (aroundTimes.indexOf(exactTime) == -1) {
      exactTime = "";
    }
    return { aroundTimes: aroundTimes, exactTime: exactTime };
  };
}

export const venueHelper = new VenueHelper();
